const loopback = new Set(['127.0.0.1', 'localhost', '::1']);

function required(name: keyof ImportMetaEnv): string {
  const value = import.meta.env[name]?.trim();
  if (!value) throw new Error(`Configuration manquante : ${name}`);
  return value;
}

export const runtimeConfig = {
  firebase: {
    apiKey: required('VITE_FIREBASE_API_KEY'),
    authDomain: required('VITE_FIREBASE_AUTH_DOMAIN'),
    projectId: required('VITE_FIREBASE_PROJECT_ID'),
    appId: required('VITE_FIREBASE_APP_ID'),
  },
  apiBase: required('VITE_STAFF_ACCESS_API_BASE').replace(/\/$/, ''),
  authEmulatorUrl: import.meta.env.VITE_AUTH_EMULATOR_URL?.trim() || null,
};

export function verifiedAuthEmulator(config = runtimeConfig): string | null {
  if (!config.authEmulatorUrl) return null;
  const url = new URL(config.authEmulatorUrl);
  if (!config.firebase.projectId.startsWith('demo-') || url.protocol !== 'http:' || !loopback.has(url.hostname)) {
    throw new Error("L'émulateur Auth exige un projet demo-* et une adresse loopback explicite.");
  }
  return url.origin;
}
